import { apiCall } from './BaseAction';
import { GetSurveyList, TGetSurveyListAction, TSurveyRespondentId } from '../types/Survey';
import { Dispatch } from 'redux';
import {
  ClearInspectionPhotos,
  CreateInspectionTask,
  DeleteInspectionPhoto,
  GetInspectionTaskAssignees,
  ReportInspectionPhotos,
  SaveInspectionQuestionData,
  TClearInspectionPhotos,
  TCreateInspectionTaskAction,
  TDeleteInspectionPhotoAction,
  TGetInspectionTaskAssigneesAction,
  TInspectionTaskCreateRequest,
  TReportInspectionPhotosAction,
  TSaveInspectionQuestionDataAction,
  TUploadInspectionPhotoAction,
  UploadInspectionPhoto,
} from '../types/Inspection';

export const getInspectionList = () => {
  return apiCall<TGetSurveyListAction, null>(
    GetSurveyList,
    'GET',
    '/inspections',
    true
  );
};

export const setInspectionQuestion = (status: boolean) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.SET,
      payload: {
        status,
      },
    });
  };
};

export const setInspectionSent = (sent: boolean) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.SENT,
      payload: {
        sent,
      },
    });
  };
};

export const setInspectionPhotoSent = (photoSent: boolean) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.PHOTO_SENT,
      payload: {
        photoSent,
      },
    });
  };
};

export const setInspectionLocation = (locationId: number) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.SET_LOCATION,
      payload: {
        locationId,
      },
    });
  };
};

export const setInspectionQuestionId = (questionId: number) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.SET_QUESTIONS,
      payload: {
        questionId,
      }
    })
  }
};

export type TPhotoUploadRequestData = {
  filename: string;
  content: string;
};

export const uploadPhoto = (
  filename: string,
  content: string,
  additionalData ?: Record<string, string | boolean | number>
)=> {
  return apiCall<TUploadInspectionPhotoAction, TPhotoUploadRequestData>(
    UploadInspectionPhoto,
    'POST',
    '/inspection/photo',
    true,
    { filename, content, ...additionalData}
  );
};

export const deleteInspectionPhoto = (photoId: number) => {
  return apiCall<TDeleteInspectionPhotoAction>(
    DeleteInspectionPhoto,
    'DELETE',
    `/inspection/photo/${photoId}`,
    true
  );
};

export const clearPhotos = () => {
  return (dispatch: Dispatch<TClearInspectionPhotos>) => {
    dispatch({
      type: ClearInspectionPhotos.SUBMIT
    });
  };
};

export type TInspectionPhotoRequest = {
  photos: Array<number>;
  comment: string;
  respondentId: TSurveyRespondentId;
  location?: number;
  questionId: number;
}

export const reportInspectionPhotos = (data: TInspectionPhotoRequest) => {
  return apiCall<TReportInspectionPhotosAction, TInspectionPhotoRequest>(
    ReportInspectionPhotos,
    'POST',
    '/inspection/photos',
    true,
    { ...data}
  );
};

export const setInspectionTaskSent = (taskSent: boolean) => {
  return (dispatch: Dispatch<TSaveInspectionQuestionDataAction>) => {
    dispatch({
      type: SaveInspectionQuestionData.TASK_SENT,
      payload: {
        taskSent,
      },
    });
  };
};

export const getTaskAssignees = () => {
  return apiCall<TGetInspectionTaskAssigneesAction, null>(
    GetInspectionTaskAssignees,
    'GET',
    '/tasks/assignees',
    true
  );
};

export const createInspectionTask = (data: TInspectionTaskCreateRequest) => {
  return apiCall<TCreateInspectionTaskAction, TInspectionTaskCreateRequest>(
    CreateInspectionTask,
    'POST',
    '/tasks/create',
    true,
    { ...data }
  );
};
